import api from "./apiConfig";

export const REGISTER_ASSITANT_BY_ENTERPRISE = async (data) => {
	try {
		const response = await api.post("/clientAssistants", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ASSISTANTS_BY_CLIENT = async (id) => {
	try {
		const response = await api.get(`/clientAssistantsByUser/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_ASSISTANT = async (id, data) => {
	try {
		const response = await api.put(`/clientAssistants/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const DELETE_ASSISTANT = async (id) => {
	try {
		const response = await api.delete(`/clientAssistants/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};
